/**
 * La vitrine n'a pas de logique de jeu — seulement la mesure.
 *
 * C'est pourtant la page qui décide de tout : on y arrive par un lien ou une
 * recherche, et soit on clique « Jouer », soit on repart. Sans elle dans les
 * chiffres, le taux de passage vers le jeu est aveugle.
 */
import { demarrerMesure, mesurer } from "./mesure.ts"

demarrerMesure()

for (const a of document.querySelectorAll<HTMLAnchorElement>('a[href^="/jeu"]')) {
  a.addEventListener("click", () => mesurer("clic jouer", { depuis: a.className || "lien" }))
}
